module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('carrier-information', {
    attrs: {
      "carrier_id": _vm.carrier_id
    }
  }), _vm._v(" "), (_vm.$canAccess(21, 23)) ? _c('carrier-emails', {
    attrs: {
      "carrier_id": _vm.carrier_id
    }
  }) : _vm._e(), _vm._v(" "), _c('cashflow', {
    attrs: {
      "source_id": _vm.carrier_id,
      "sourceFn": "carrierCashflow",
      "label": "Carrier",
      "name": _vm.carrierDetails.name
    }
  }), _vm._v(" "), _c('carrier-products', {
    attrs: {
      "carrier_id": _vm.carrier_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b90a5b1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/CarrierDetails.vue
// module id = 418
// module chunks = 0